import {Locale} from '../locale';
import {nativeLanguageByLocale} from '../nativeLanguageByLocale';
import {
  ASSETS_URL_DESKTOP_PRODUCTION,
  ASSETS_URL_MOBILE_PRODUCTION,
  IRIS_URL_PRODUCTION,
  KLARNA_SDK_URL_PRODUCTION,
  getDesktopHelpCenterEndpointByLocale,
} from './constants';
import {HttpUrl, UrlMapping} from './types';

const desktopHelpCenterEndpointByLocale =
  getDesktopHelpCenterEndpointByLocale(IRIS_URL_PRODUCTION);

const sendSmsEndpoint = `${IRIS_URL_PRODUCTION}/sms` as HttpUrl;

export const production: UrlMapping<'production'> = {
  [Locale.en_ZZ]: {
    environment: 'production',
    locale: Locale.en_ZZ,
    urlSets: [
      {
        hostname: 'www.aboutyou.com',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_PRODUCTION,
        legacyCheckout: 'https://checkout.aboutyou.com',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.en_ZZ],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_PRODUCTION,
        alternateLocales: [
          {
            locale: Locale.es_ZZ,
            url: 'https://es.aboutyou.com',
            nativeLanguage: nativeLanguageByLocale[Locale.es_ZZ],
          },
        ],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.com',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-live`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/production`,
        checkoutTrackingUrl: 'https://cot.aboutyou.com',
        zalandoUrl: 'https://www.zalando.com/',
      },
      {
        hostname: 'm.aboutyou.com',
        publicDesktopHostname: 'www.aboutyou.com',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_PRODUCTION,
        legacyCheckout: 'https://checkout-m.aboutyou.com',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.en_ZZ],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_PRODUCTION,
        alternateLocales: [
          {
            locale: Locale.es_ZZ,
            url: 'https://m-es.aboutyou.com',
            alternateDomainUrl: 'https://es.aboutyou.com',
            nativeLanguage: nativeLanguageByLocale[Locale.es_ZZ],
          },
        ],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.com',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-live`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/production`,
        checkoutTrackingUrl: 'https://cot.aboutyou.com',
        zalandoUrl: 'https://www.zalando.com/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.es_ZZ]: {
    environment: 'production',
    locale: Locale.es_ZZ,
    urlSets: [
      {
        hostname: 'es.aboutyou.com',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_PRODUCTION,
        legacyCheckout: 'https://checkout-es.aboutyou.com',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.es_ZZ],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_PRODUCTION,
        alternateLocales: [
          {
            locale: Locale.en_ZZ,
            url: 'https://www.aboutyou.com',
            nativeLanguage: nativeLanguageByLocale[Locale.en_ZZ],
          },
        ],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.com',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-live`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/production`,
        checkoutTrackingUrl: 'https://cot.aboutyou.com',
        zalandoUrl: 'https://www.zalando.com/',
      },
      {
        hostname: 'm-es.aboutyou.com',
        publicDesktopHostname: 'es.aboutyou.com',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_PRODUCTION,
        legacyCheckout: 'https://checkout-m-es.aboutyou.com',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.es_ZZ],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_PRODUCTION,
        alternateLocales: [
          {
            locale: Locale.en_ZZ,
            url: 'https://m.aboutyou.com',
            alternateDomainUrl: 'https://www.aboutyou.com',
            nativeLanguage: nativeLanguageByLocale[Locale.en_ZZ],
          },
        ],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.com',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-live`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/production`,
        checkoutTrackingUrl: 'https://cot.aboutyou.com',
        zalandoUrl: 'https://www.zalando.com/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.de_DE]: {
    environment: 'production',
    locale: Locale.de_DE,
    urlSets: [
      {
        hostname: 'www.aboutyou.de',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_PRODUCTION,
        legacyCheckout: 'https://checkout.aboutyou.de',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.de_DE],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_PRODUCTION,
        alternateLocales: [
          {
            locale: Locale.en_DE,
            url: 'https://en.aboutyou.de',
            nativeLanguage: nativeLanguageByLocale[Locale.en_DE],
          },
        ],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.de',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-live`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/production`,
        checkoutTrackingUrl: 'https://cot.aboutyou.com',
        zalandoUrl: 'https://www.zalando.de/',
      },
      {
        hostname: 'm.aboutyou.de',
        publicDesktopHostname: 'www.aboutyou.de',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_PRODUCTION,
        legacyCheckout: 'https://checkout-m.aboutyou.de',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.de_DE],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_PRODUCTION,
        alternateLocales: [
          {
            locale: Locale.en_DE,
            url: 'https://m-en.aboutyou.de',
            alternateDomainUrl: 'https://en.aboutyou.de',
            nativeLanguage: nativeLanguageByLocale[Locale.en_DE],
          },
        ],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.de',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-live`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/production`,
        checkoutTrackingUrl: 'https://cot.aboutyou.com',
        zalandoUrl: 'https://www.zalando.de/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.en_DE]: {
    environment: 'production',
    locale: Locale.en_DE,
    urlSets: [
      {
        hostname: 'en.aboutyou.de',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_PRODUCTION,
        legacyCheckout: 'https://checkout-en.aboutyou.de',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.en_DE],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_PRODUCTION,
        alternateLocales: [
          {
            locale: Locale.de_DE,
            url: 'https://www.aboutyou.de',
            nativeLanguage: nativeLanguageByLocale[Locale.de_DE],
          },
        ],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.de',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-live`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/production`,
        checkoutTrackingUrl: 'https://cot.aboutyou.com',
        zalandoUrl: 'https://en.zalando.de/',
      },
      {
        hostname: 'm-en.aboutyou.de',
        publicDesktopHostname: 'en.aboutyou.de',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_PRODUCTION,
        legacyCheckout: 'https://checkout-m-en.aboutyou.de',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.en_DE],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_PRODUCTION,
        alternateLocales: [
          {
            locale: Locale.de_DE,
            url: 'https://m.aboutyou.de',
            alternateDomainUrl: 'https://www.aboutyou.de',
            nativeLanguage: nativeLanguageByLocale[Locale.de_DE],
          },
        ],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.de',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-live`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/production`,
        checkoutTrackingUrl: 'https://cot.aboutyou.com',
        zalandoUrl: 'https://en.zalando.de/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.de_AT]: {
    environment: 'production',
    locale: Locale.de_AT,
    urlSets: [
      {
        hostname: 'www.aboutyou.at',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_PRODUCTION,
        legacyCheckout: 'https://checkout.aboutyou.at',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.de_AT],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.at',
        sms_POST: sendSmsEndpoint,
        alternateLocales: [
          {
            locale: Locale.en_AT,
            url: 'https://en.aboutyou.at',
            nativeLanguage: nativeLanguageByLocale[Locale.en_AT],
          },
        ],
        klarnaSdkUrl: KLARNA_SDK_URL_PRODUCTION,
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-live`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/production`,
        checkoutTrackingUrl: 'https://cot.aboutyou.com',
        zalandoUrl: 'https://www.zalando.at/',
      },
      {
        hostname: 'm.aboutyou.at',
        publicDesktopHostname: 'www.aboutyou.at',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_PRODUCTION,
        legacyCheckout: 'https://checkout-m.aboutyou.at',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.de_AT],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.at',
        sms_POST: sendSmsEndpoint,
        alternateLocales: [
          {
            locale: Locale.en_AT,
            url: 'https://m-en.aboutyou.at',
            alternateDomainUrl: 'https://en.aboutyou.at',
            nativeLanguage: nativeLanguageByLocale[Locale.en_AT],
          },
        ],
        klarnaSdkUrl: KLARNA_SDK_URL_PRODUCTION,
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-live`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/production`,
        checkoutTrackingUrl: 'https://cot.aboutyou.com',
        zalandoUrl: 'https://www.zalando.at/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.en_AT]: {
    environment: 'production',
    locale: Locale.en_AT,
    urlSets: [
      {
        hostname: 'en.aboutyou.at',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_PRODUCTION,
        legacyCheckout: 'https://checkout-en.aboutyou.at',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.en_AT],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.at',
        sms_POST: sendSmsEndpoint,
        alternateLocales: [
          {
            locale: Locale.de_AT,
            url: 'https://www.aboutyou.at',
            nativeLanguage: nativeLanguageByLocale[Locale.de_AT],
          },
        ],
        klarnaSdkUrl: KLARNA_SDK_URL_PRODUCTION,
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-live`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/production`,
        checkoutTrackingUrl: 'https://cot.aboutyou.com',
        zalandoUrl: 'https://www.zalando.at/',
      },
      {
        hostname: 'm-en.aboutyou.at',
        publicDesktopHostname: 'en.aboutyou.at',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_PRODUCTION,
        legacyCheckout: 'https://checkout-m-en.aboutyou.at',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.en_AT],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.at',
        sms_POST: sendSmsEndpoint,
        alternateLocales: [
          {
            locale: Locale.de_AT,
            url: 'https://m.aboutyou.at',
            alternateDomainUrl: 'https://www.aboutyou.at',
            nativeLanguage: nativeLanguageByLocale[Locale.de_AT],
          },
        ],
        klarnaSdkUrl: KLARNA_SDK_URL_PRODUCTION,
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-live`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/production`,
        checkoutTrackingUrl: 'https://cot.aboutyou.com',
        zalandoUrl: 'https://www.zalando.at/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.de_CH]: {
    environment: 'production',
    locale: Locale.de_CH,
    urlSets: [
      {
        hostname: 'www.aboutyou.ch',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_PRODUCTION,
        legacyCheckout: 'https://checkout.aboutyou.ch',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.de_CH],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_PRODUCTION,
        alternateLocales: [
          {
            locale: Locale.fr_CH,
            url: 'https://fr.aboutyou.ch',
            nativeLanguage: nativeLanguageByLocale[Locale.fr_CH],
          },
          {
            locale: Locale.it_CH,
            url: 'https://it.aboutyou.ch',
            nativeLanguage: nativeLanguageByLocale[Locale.it_CH],
          },
          {
            locale: Locale.en_CH,
            url: 'https://en.aboutyou.ch',
            nativeLanguage: nativeLanguageByLocale[Locale.en_CH],
          },
        ],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.ch',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-live`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/production`,
        checkoutTrackingUrl: 'https://cot.aboutyou.com',
        zalandoUrl: 'https://www.zalando.ch/',
      },
      {
        hostname: 'm.aboutyou.ch',
        publicDesktopHostname: 'www.aboutyou.ch',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_PRODUCTION,
        legacyCheckout: 'https://checkout-m.aboutyou.ch',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.de_CH],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_PRODUCTION,
        alternateLocales: [
          {
            locale: Locale.fr_CH,
            url: 'https://m-fr.aboutyou.ch',
            alternateDomainUrl: 'https://fr.aboutyou.ch',
            nativeLanguage: nativeLanguageByLocale[Locale.fr_CH],
          },
          {
            locale: Locale.it_CH,
            url: 'https://m-it.aboutyou.ch',
            alternateDomainUrl: 'https://it.aboutyou.ch',
            nativeLanguage: nativeLanguageByLocale[Locale.it_CH],
          },
          {
            locale: Locale.en_CH,
            url: 'https://m-en.aboutyou.ch',
            alternateDomainUrl: 'https://en.aboutyou.ch',
            nativeLanguage: nativeLanguageByLocale[Locale.en_CH],
          },
        ],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.ch',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-live`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/production`,
        checkoutTrackingUrl: 'https://cot.aboutyou.com',
        zalandoUrl: 'https://www.zalando.ch/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.fr_CH]: {
    environment: 'production',
    locale: Locale.fr_CH,
    urlSets: [
      {
        hostname: 'fr.aboutyou.ch',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_PRODUCTION,
        legacyCheckout: 'https://checkout-fr.aboutyou.ch',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.fr_CH],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_PRODUCTION,
        alternateLocales: [
          {
            locale: Locale.de_CH,
            url: 'https://www.aboutyou.ch',
            nativeLanguage: nativeLanguageByLocale[Locale.de_CH],
          },
          {
            locale: Locale.it_CH,
            url: 'https://it.aboutyou.ch',
            nativeLanguage: nativeLanguageByLocale[Locale.it_CH],
          },
          {
            locale: Locale.en_CH,
            url: 'https://en.aboutyou.ch',
            nativeLanguage: nativeLanguageByLocale[Locale.en_CH],
          },
        ],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.ch',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-live`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/production`,
        checkoutTrackingUrl: 'https://cot.aboutyou.com',
        zalandoUrl: 'https://fr.zalando.ch/',
      },
      {
        hostname: 'm-fr.aboutyou.ch',
        publicDesktopHostname: 'fr.aboutyou.ch',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_PRODUCTION,
        legacyCheckout: 'https://checkout-m-fr.aboutyou.ch',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.fr_CH],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_PRODUCTION,
        alternateLocales: [
          {
            locale: Locale.de_CH,
            url: 'https://m.aboutyou.ch',
            alternateDomainUrl: 'https://www.aboutyou.ch',
            nativeLanguage: nativeLanguageByLocale[Locale.de_CH],
          },
          {
            locale: Locale.it_CH,
            url: 'https://m-it.aboutyou.ch',
            alternateDomainUrl: 'https://it.aboutyou.ch',
            nativeLanguage: nativeLanguageByLocale[Locale.it_CH],
          },
          {
            locale: Locale.en_CH,
            url: 'https://m-en.aboutyou.ch',
            alternateDomainUrl: 'https://en.aboutyou.ch',
            nativeLanguage: nativeLanguageByLocale[Locale.en_CH],
          },
        ],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.ch',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-live`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/production`,
        checkoutTrackingUrl: 'https://cot.aboutyou.com',
        zalandoUrl: 'https://fr.zalando.ch/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.it_CH]: {
    environment: 'production',
    locale: Locale.it_CH,
    urlSets: [
      {
        hostname: 'it.aboutyou.ch',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_PRODUCTION,
        legacyCheckout: 'https://checkout-it.aboutyou.ch',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.it_CH],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_PRODUCTION,
        alternateLocales: [
          {
            locale: Locale.de_CH,
            url: 'https://www.aboutyou.ch',
            nativeLanguage: nativeLanguageByLocale[Locale.de_CH],
          },
          {
            locale: Locale.fr_CH,
            url: 'https://fr.aboutyou.ch',
            nativeLanguage: nativeLanguageByLocale[Locale.fr_CH],
          },
          {
            locale: Locale.en_CH,
            url: 'https://en.aboutyou.ch',
            nativeLanguage: nativeLanguageByLocale[Locale.en_CH],
          },
        ],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.ch',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-live`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/production`,
        checkoutTrackingUrl: 'https://cot.aboutyou.com',
        zalandoUrl: 'https://it.zalando.ch/',
      },
      {
        hostname: 'm-it.aboutyou.ch',
        publicDesktopHostname: 'it.aboutyou.ch',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_PRODUCTION,
        legacyCheckout: 'https://checkout-m-it.aboutyou.ch',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.it_CH],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_PRODUCTION,
        alternateLocales: [
          {
            locale: Locale.de_CH,
            url: 'https://m.aboutyou.ch',
            alternateDomainUrl: 'https://www.aboutyou.ch',
            nativeLanguage: nativeLanguageByLocale[Locale.de_CH],
          },
          {
            locale: Locale.fr_CH,
            url: 'https://m-fr.aboutyou.ch',
            alternateDomainUrl: 'https://fr.aboutyou.ch',
            nativeLanguage: nativeLanguageByLocale[Locale.fr_CH],
          },
          {
            locale: Locale.en_CH,
            url: 'https://m-en.aboutyou.ch',
            alternateDomainUrl: 'https://en.aboutyou.ch',
            nativeLanguage: nativeLanguageByLocale[Locale.en_CH],
          },
        ],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.ch',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-live`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/production`,
        checkoutTrackingUrl: 'https://cot.aboutyou.com',
        zalandoUrl: 'https://it.zalando.ch/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.en_CH]: {
    environment: 'production',
    locale: Locale.en_CH,
    urlSets: [
      {
        hostname: 'en.aboutyou.ch',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_PRODUCTION,
        legacyCheckout: 'https://checkout-en.aboutyou.ch',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.en_CH],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_PRODUCTION,
        alternateLocales: [
          {
            locale: Locale.de_CH,
            url: 'https://www.aboutyou.ch',
            nativeLanguage: nativeLanguageByLocale[Locale.de_CH],
          },
          {
            locale: Locale.fr_CH,
            url: 'https://fr.aboutyou.ch',
            nativeLanguage: nativeLanguageByLocale[Locale.fr_CH],
          },
          {
            locale: Locale.it_CH,
            url: 'https://it.aboutyou.ch',
            nativeLanguage: nativeLanguageByLocale[Locale.it_CH],
          },
        ],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.ch',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-live`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/production`,
        checkoutTrackingUrl: 'https://cot.aboutyou.com',
        zalandoUrl: 'https://www.zalando.ch/',
      },
      {
        hostname: 'm-en.aboutyou.ch',
        publicDesktopHostname: 'en.aboutyou.ch',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_PRODUCTION,
        legacyCheckout: 'https://checkout-m-en.aboutyou.ch',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.en_CH],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_PRODUCTION,
        alternateLocales: [
          {
            locale: Locale.de_CH,
            url: 'https://m.aboutyou.ch',
            alternateDomainUrl: 'https://www.aboutyou.ch',
            nativeLanguage: nativeLanguageByLocale[Locale.de_CH],
          },
          {
            locale: Locale.fr_CH,
            url: 'https://m-fr.aboutyou.ch',
            alternateDomainUrl: 'https://fr.aboutyou.ch',
            nativeLanguage: nativeLanguageByLocale[Locale.fr_CH],
          },
          {
            locale: Locale.it_CH,
            url: 'https://m-it.aboutyou.ch',
            alternateDomainUrl: 'https://it.aboutyou.ch',
            nativeLanguage: nativeLanguageByLocale[Locale.it_CH],
          },
        ],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.ch',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-live`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/production`,
        checkoutTrackingUrl: 'https://cot.aboutyou.com',
        zalandoUrl: 'https://www.zalando.ch/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.nl_NL]: {
    environment: 'production',
    locale: Locale.nl_NL,
    urlSets: [
      {
        hostname: 'www.aboutyou.nl',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_PRODUCTION,
        legacyCheckout: 'https://checkout.aboutyou.nl',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.nl_NL],
        sms_POST: sendSmsEndpoint,
        alternateLocales: [
          {
            locale: Locale.en_NL,
            url: 'https://en.aboutyou.nl',
            nativeLanguage: nativeLanguageByLocale[Locale.en_NL],
          },
        ],
        klarnaSdkUrl: KLARNA_SDK_URL_PRODUCTION,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.nl',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-live`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/production`,
        checkoutTrackingUrl: 'https://cot.aboutyou.com',
        zalandoUrl: 'https://www.zalando.nl/',
      },
      {
        hostname: 'm.aboutyou.nl',
        publicDesktopHostname: 'www.aboutyou.nl',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_PRODUCTION,
        legacyCheckout: 'https://checkout-m.aboutyou.nl',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.nl_NL],
        sms_POST: sendSmsEndpoint,
        alternateLocales: [
          {
            locale: Locale.en_NL,
            url: 'https://m-en.aboutyou.nl',
            alternateDomainUrl: 'https://en.aboutyou.nl',
            nativeLanguage: nativeLanguageByLocale[Locale.en_NL],
          },
        ],
        klarnaSdkUrl: KLARNA_SDK_URL_PRODUCTION,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.nl',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-live`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/production`,
        checkoutTrackingUrl: 'https://cot.aboutyou.com',
        zalandoUrl: 'https://www.zalando.nl/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.en_NL]: {
    environment: 'production',
    locale: Locale.en_NL,
    urlSets: [
      {
        hostname: 'en.aboutyou.nl',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_PRODUCTION,
        legacyCheckout: 'https://checkout-en.aboutyou.nl',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.en_NL],
        sms_POST: sendSmsEndpoint,
        alternateLocales: [
          {
            locale: Locale.nl_NL,
            url: 'https://www.aboutyou.nl',
            nativeLanguage: nativeLanguageByLocale[Locale.nl_NL],
          },
        ],
        klarnaSdkUrl: KLARNA_SDK_URL_PRODUCTION,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.nl',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-live`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/production`,
        checkoutTrackingUrl: 'https://cot.aboutyou.com',
        zalandoUrl: 'https://en.zalando.nl/',
      },
      {
        hostname: 'm-en.aboutyou.nl',
        publicDesktopHostname: 'en.aboutyou.nl',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_PRODUCTION,
        legacyCheckout: 'https://checkout-m-en.aboutyou.nl',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.en_NL],
        sms_POST: sendSmsEndpoint,
        alternateLocales: [
          {
            locale: Locale.nl_NL,
            url: 'https://m.aboutyou.nl',
            alternateDomainUrl: 'https://www.aboutyou.nl',
            nativeLanguage: nativeLanguageByLocale[Locale.nl_NL],
          },
        ],
        klarnaSdkUrl: KLARNA_SDK_URL_PRODUCTION,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.nl',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-live`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/production`,
        checkoutTrackingUrl: 'https://cot.aboutyou.com',
        zalandoUrl: 'https://en.zalando.nl/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.pl_PL]: {
    environment: 'production',
    locale: Locale.pl_PL,
    urlSets: [
      {
        hostname: 'www.aboutyou.pl',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_PRODUCTION,
        legacyCheckout: 'https://checkout.aboutyou.pl',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.pl_PL],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_PRODUCTION,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.pl',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-live`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/production`,
        checkoutTrackingUrl: 'https://cot.aboutyou.com',
        zalandoUrl: 'https://www.zalando.pl/',
      },
      {
        hostname: 'm.aboutyou.pl',
        publicDesktopHostname: 'www.aboutyou.pl',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_PRODUCTION,
        legacyCheckout: 'https://checkout-m.aboutyou.pl',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.pl_PL],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_PRODUCTION,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.pl',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-live`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/production`,
        checkoutTrackingUrl: 'https://cot.aboutyou.com',
        zalandoUrl: 'https://www.zalando.pl/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.nl_BE]: {
    environment: 'production',
    locale: Locale.nl_BE,
    urlSets: [
      {
        hostname: 'www.aboutyou.be',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_PRODUCTION,
        legacyCheckout: 'https://checkout.aboutyou.be',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.nl_BE],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_PRODUCTION,
        alternateLocales: [
          {
            locale: Locale.fr_BE,
            url: 'https://fr.aboutyou.be',
            nativeLanguage: nativeLanguageByLocale[Locale.fr_BE],
          },
        ],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.be',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-live`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/production`,
        checkoutTrackingUrl: 'https://cot.aboutyou.com',
        zalandoUrl: 'https://www.zalando.be/',
      },
      {
        hostname: 'm.aboutyou.be',
        publicDesktopHostname: 'www.aboutyou.be',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_PRODUCTION,
        legacyCheckout: 'https://checkout-m.aboutyou.be',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.nl_BE],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_PRODUCTION,
        alternateLocales: [
          {
            locale: Locale.fr_BE,
            url: 'https://m-fr.aboutyou.be',
            alternateDomainUrl: 'https://fr.aboutyou.be',
            nativeLanguage: nativeLanguageByLocale[Locale.fr_BE],
          },
        ],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.be',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-live`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/production`,
        checkoutTrackingUrl: 'https://cot.aboutyou.com',
        zalandoUrl: 'https://www.zalando.be/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.fr_BE]: {
    environment: 'production',
    locale: Locale.fr_BE,
    urlSets: [
      {
        hostname: 'fr.aboutyou.be',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_PRODUCTION,
        legacyCheckout: 'https://checkout-fr.aboutyou.be',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.fr_BE],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_PRODUCTION,
        alternateLocales: [
          {
            locale: Locale.nl_BE,
            url: 'https://www.aboutyou.be',
            nativeLanguage: nativeLanguageByLocale[Locale.nl_BE],
          },
        ],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.be',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-live`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/production`,
        checkoutTrackingUrl: 'https://cot.aboutyou.com',
        zalandoUrl: 'https://fr.zalando.be/',
      },
      {
        hostname: 'm-fr.aboutyou.be',
        publicDesktopHostname: 'fr.aboutyou.be',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_PRODUCTION,
        legacyCheckout: 'https://checkout-m-fr.aboutyou.be',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.fr_BE],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_PRODUCTION,
        alternateLocales: [
          {
            locale: Locale.nl_BE,
            url: 'https://m.aboutyou.be',
            alternateDomainUrl: 'https://www.aboutyou.be',
            nativeLanguage: nativeLanguageByLocale[Locale.nl_BE],
          },
        ],
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.be',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-live`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/production`,
        checkoutTrackingUrl: 'https://cot.aboutyou.com',
        zalandoUrl: 'https://fr.zalando.be/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.cs_CZ]: {
    environment: 'production',
    locale: Locale.cs_CZ,
    urlSets: [
      {
        hostname: 'www.aboutyou.cz',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_PRODUCTION,
        legacyCheckout: 'https://checkout.aboutyou.cz',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.cs_CZ],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_PRODUCTION,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.cz',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-live`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/production`,
        checkoutTrackingUrl: 'https://cot.aboutyou.com',
        zalandoUrl: 'https://www.zalando.cz/',
      },
      {
        hostname: 'm.aboutyou.cz',
        publicDesktopHostname: 'www.aboutyou.cz',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_PRODUCTION,
        legacyCheckout: 'https://checkout-m.aboutyou.cz',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.cs_CZ],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_PRODUCTION,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.cz',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-live`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/production`,
        checkoutTrackingUrl: 'https://cot.aboutyou.com',
        zalandoUrl: 'https://www.zalando.cz/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.ro_RO]: {
    environment: 'production',
    locale: Locale.ro_RO,
    urlSets: [
      {
        hostname: 'www.aboutyou.ro',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_PRODUCTION,
        legacyCheckout: 'https://checkout.aboutyou.ro',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.ro_RO],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_PRODUCTION,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.ro',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-live`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/production`,
        checkoutTrackingUrl: 'https://cot.aboutyou.com',
        zalandoUrl: 'https://www.zalando.ro/',
      },
      {
        hostname: 'm.aboutyou.ro',
        publicDesktopHostname: 'www.aboutyou.ro',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_PRODUCTION,
        legacyCheckout: 'https://checkout-m.aboutyou.ro',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.ro_RO],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_PRODUCTION,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.ro',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-live`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/production`,
        checkoutTrackingUrl: 'https://cot.aboutyou.com',
        zalandoUrl: 'https://www.zalando.ro/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.hu_HU]: {
    environment: 'production',
    locale: Locale.hu_HU,
    urlSets: [
      {
        hostname: 'www.aboutyou.hu',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_PRODUCTION,
        legacyCheckout: 'https://checkout.aboutyou.hu',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.hu_HU],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_PRODUCTION,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.hu',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-live`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/production`,
        checkoutTrackingUrl: 'https://cot.aboutyou.com',
        zalandoUrl: 'https://www.zalando.hu/',
      },
      {
        hostname: 'm.aboutyou.hu',
        publicDesktopHostname: 'www.aboutyou.hu',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_PRODUCTION,
        legacyCheckout: 'https://checkout-m.aboutyou.hu',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.hu_HU],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_PRODUCTION,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.hu',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-live`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/production`,
        checkoutTrackingUrl: 'https://cot.aboutyou.com',
        zalandoUrl: 'https://www.zalando.hu/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.sk_SK]: {
    environment: 'production',
    locale: Locale.sk_SK,
    urlSets: [
      {
        hostname: 'www.aboutyou.sk',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_PRODUCTION,
        legacyCheckout: 'https://checkout.aboutyou.sk',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.sk_SK],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_PRODUCTION,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.sk',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-live`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/production`,
        checkoutTrackingUrl: 'https://cot.aboutyou.com',
        zalandoUrl: 'https://www.zalando.sk/',
      },
      {
        hostname: 'm.aboutyou.sk',
        publicDesktopHostname: 'www.aboutyou.sk',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_PRODUCTION,
        legacyCheckout: 'https://checkout-m.aboutyou.sk',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.sk_SK],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_PRODUCTION,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.sk',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-live`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/production`,
        checkoutTrackingUrl: 'https://cot.aboutyou.com',
        zalandoUrl: 'https://www.zalando.sk/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.sl_SI]: {
    environment: 'production',
    locale: Locale.sl_SI,
    urlSets: [
      {
        hostname: 'www.aboutyou.si',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_PRODUCTION,
        legacyCheckout: 'https://checkout.aboutyou.si',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.sl_SI],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_PRODUCTION,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.si',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-live`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/production`,
        checkoutTrackingUrl: 'https://cot.aboutyou.com',
        zalandoUrl: 'https://www.zalando.si/',
      },
      {
        hostname: 'm.aboutyou.si',
        publicDesktopHostname: 'www.aboutyou.si',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_PRODUCTION,
        legacyCheckout: 'https://checkout-m.aboutyou.si',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.sl_SI],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_PRODUCTION,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.si',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-live`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/production`,
        checkoutTrackingUrl: 'https://cot.aboutyou.com',
        zalandoUrl: 'https://www.zalando.si/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.lv_LV]: {
    environment: 'production',
    locale: Locale.lv_LV,
    urlSets: [
      {
        hostname: 'www.aboutyou.lv',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_PRODUCTION,
        legacyCheckout: 'https://checkout.aboutyou.lv',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.lv_LV],
        sms_POST: sendSmsEndpoint,
        alternateLocales: [
          {
            locale: Locale.ru_LV,
            url: 'https://ru.aboutyou.lv',
            nativeLanguage: nativeLanguageByLocale[Locale.ru_LV],
          },
        ],
        klarnaSdkUrl: KLARNA_SDK_URL_PRODUCTION,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.lv',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-live`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/production`,
        checkoutTrackingUrl: 'https://cot.aboutyou.com',
        zalandoUrl: 'https://www.zalando.lv/',
      },
      {
        hostname: 'm.aboutyou.lv',
        publicDesktopHostname: 'www.aboutyou.lv',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_PRODUCTION,
        legacyCheckout: 'https://checkout-m.aboutyou.lv',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.lv_LV],
        sms_POST: sendSmsEndpoint,
        alternateLocales: [
          {
            locale: Locale.ru_LV,
            url: 'https://m-ru.aboutyou.lv',
            alternateDomainUrl: 'https://ru.aboutyou.lv',
            nativeLanguage: nativeLanguageByLocale[Locale.ru_LV],
          },
        ],
        klarnaSdkUrl: KLARNA_SDK_URL_PRODUCTION,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.lv',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-live`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/production`,
        checkoutTrackingUrl: 'https://cot.aboutyou.com',
        zalandoUrl: 'https://www.zalando.lv/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.ru_LV]: {
    environment: 'production',
    locale: Locale.ru_LV,
    urlSets: [
      {
        hostname: 'ru.aboutyou.lv',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_PRODUCTION,
        legacyCheckout: 'https://checkout-ru.aboutyou.lv',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.ru_LV],
        sms_POST: sendSmsEndpoint,
        alternateLocales: [
          {
            locale: Locale.lv_LV,
            url: 'https://www.aboutyou.lv',
            nativeLanguage: nativeLanguageByLocale[Locale.lv_LV],
          },
        ],
        klarnaSdkUrl: KLARNA_SDK_URL_PRODUCTION,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.lv',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-live`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/production`,
        checkoutTrackingUrl: 'https://cot.aboutyou.com',
        zalandoUrl: 'https://www.zalando.lv/',
      },
      {
        hostname: 'm-ru.aboutyou.lv',
        publicDesktopHostname: 'ru.aboutyou.lv',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_PRODUCTION,
        legacyCheckout: 'https://checkout-m-ru.aboutyou.lv',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.ru_LV],
        sms_POST: sendSmsEndpoint,
        alternateLocales: [
          {
            locale: Locale.lv_LV,
            url: 'https://m.aboutyou.lv',
            alternateDomainUrl: 'https://www.aboutyou.lv',
            nativeLanguage: nativeLanguageByLocale[Locale.lv_LV],
          },
        ],
        klarnaSdkUrl: KLARNA_SDK_URL_PRODUCTION,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.lv',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-live`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/production`,
        checkoutTrackingUrl: 'https://cot.aboutyou.com',
        zalandoUrl: 'https://www.zalando.lv/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.lt_LT]: {
    environment: 'production',
    locale: Locale.lt_LT,
    urlSets: [
      {
        hostname: 'www.aboutyou.lt',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_PRODUCTION,
        legacyCheckout: 'https://checkout.aboutyou.lt',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.lt_LT],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_PRODUCTION,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.lt',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-live`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/production`,
        checkoutTrackingUrl: 'https://cot.aboutyou.com',
        zalandoUrl: 'https://www.zalando.lt/',
      },
      {
        hostname: 'm.aboutyou.lt',
        publicDesktopHostname: 'www.aboutyou.lt',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_PRODUCTION,
        legacyCheckout: 'https://checkout-m.aboutyou.lt',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.lt_LT],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_PRODUCTION,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.lt',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-live`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/production`,
        checkoutTrackingUrl: 'https://cot.aboutyou.com',
        zalandoUrl: 'https://www.zalando.lt/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.et_EE]: {
    environment: 'production',
    locale: Locale.et_EE,
    urlSets: [
      {
        hostname: 'www.aboutyou.ee',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_PRODUCTION,
        legacyCheckout: 'https://checkout.aboutyou.ee',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.et_EE],
        sms_POST: sendSmsEndpoint,
        alternateLocales: [
          {
            locale: Locale.ru_EE,
            url: 'https://ru.aboutyou.ee',
            nativeLanguage: nativeLanguageByLocale[Locale.ru_EE],
          },
        ],
        klarnaSdkUrl: KLARNA_SDK_URL_PRODUCTION,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.ee',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-live`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/production`,
        checkoutTrackingUrl: 'https://cot.aboutyou.com',
        zalandoUrl: 'https://www.zalando.ee/',
      },
      {
        hostname: 'm.aboutyou.ee',
        publicDesktopHostname: 'www.aboutyou.ee',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_PRODUCTION,
        legacyCheckout: 'https://checkout-m.aboutyou.ee',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.et_EE],
        sms_POST: sendSmsEndpoint,
        alternateLocales: [
          {
            locale: Locale.ru_EE,
            url: 'https://m-ru.aboutyou.ee',
            alternateDomainUrl: 'https://ru.aboutyou.ee',
            nativeLanguage: nativeLanguageByLocale[Locale.ru_EE],
          },
        ],
        klarnaSdkUrl: KLARNA_SDK_URL_PRODUCTION,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.ee',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-live`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/production`,
        checkoutTrackingUrl: 'https://cot.aboutyou.com',
        zalandoUrl: 'https://www.zalando.ee/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.ru_EE]: {
    environment: 'production',
    locale: Locale.ru_EE,
    urlSets: [
      {
        hostname: 'ru.aboutyou.ee',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_PRODUCTION,
        legacyCheckout: 'https://checkout-ru.aboutyou.ee',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.ru_EE],
        sms_POST: sendSmsEndpoint,
        alternateLocales: [
          {
            locale: Locale.et_EE,
            url: 'https://www.aboutyou.ee',
            nativeLanguage: nativeLanguageByLocale[Locale.et_EE],
          },
        ],
        klarnaSdkUrl: KLARNA_SDK_URL_PRODUCTION,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.ee',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-live`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/production`,
        checkoutTrackingUrl: 'https://cot.aboutyou.com',
        zalandoUrl: 'https://www.zalando.ee/',
      },
      {
        hostname: 'm-ru.aboutyou.ee',
        publicDesktopHostname: 'ru.aboutyou.ee',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_PRODUCTION,
        legacyCheckout: 'https://checkout-m-ru.aboutyou.ee',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.ru_EE],
        sms_POST: sendSmsEndpoint,
        alternateLocales: [
          {
            locale: Locale.et_EE,
            url: 'https://m.aboutyou.ee',
            alternateDomainUrl: 'https://www.aboutyou.ee',
            nativeLanguage: nativeLanguageByLocale[Locale.et_EE],
          },
        ],
        klarnaSdkUrl: KLARNA_SDK_URL_PRODUCTION,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.ee',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-live`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/production`,
        checkoutTrackingUrl: 'https://cot.aboutyou.com',
        zalandoUrl: 'https://www.zalando.ee/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.hr_HR]: {
    environment: 'production',
    locale: Locale.hr_HR,
    urlSets: [
      {
        hostname: 'www.aboutyou.hr',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_PRODUCTION,
        legacyCheckout: 'https://checkout.aboutyou.hr',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.hr_HR],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_PRODUCTION,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.hr',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-live`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/production`,
        checkoutTrackingUrl: 'https://cot.aboutyou.com',
        zalandoUrl: 'https://www.zalando.hr/',
      },
      {
        hostname: 'm.aboutyou.hr',
        publicDesktopHostname: 'www.aboutyou.hr',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_PRODUCTION,
        legacyCheckout: 'https://checkout-m.aboutyou.hr',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.hr_HR],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_PRODUCTION,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.hr',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-live`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/production`,
        checkoutTrackingUrl: 'https://cot.aboutyou.com',
        zalandoUrl: 'https://www.zalando.hr/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.bg_BG]: {
    environment: 'production',
    locale: Locale.bg_BG,
    urlSets: [
      {
        hostname: 'www.aboutyou.bg',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_PRODUCTION,
        legacyCheckout: 'https://checkout.aboutyou.bg',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.bg_BG],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_PRODUCTION,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.bg',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-live`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/production`,
        checkoutTrackingUrl: 'https://cot.aboutyou.com',
        zalandoUrl: 'https://www.zalando.com/',
      },
      {
        hostname: 'm.aboutyou.bg',
        publicDesktopHostname: 'www.aboutyou.bg',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_PRODUCTION,
        legacyCheckout: 'https://checkout-m.aboutyou.bg',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.bg_BG],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_PRODUCTION,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.bg',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-live`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/production`,
        checkoutTrackingUrl: 'https://cot.aboutyou.com',
        zalandoUrl: 'https://www.zalando.com/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.fr_FR]: {
    environment: 'production',
    locale: Locale.fr_FR,
    urlSets: [
      {
        hostname: 'www.aboutyou.fr',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_PRODUCTION,
        legacyCheckout: 'https://checkout.aboutyou.fr',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.fr_FR],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_PRODUCTION,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.fr',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-live`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/production`,
        checkoutTrackingUrl: 'https://cot.aboutyou.com',
        zalandoUrl: 'https://www.zalando.fr/',
      },
      {
        hostname: 'm.aboutyou.fr',
        publicDesktopHostname: 'www.aboutyou.fr',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_PRODUCTION,
        legacyCheckout: 'https://checkout-m.aboutyou.fr',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.fr_FR],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_PRODUCTION,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.fr',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-live`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/production`,
        checkoutTrackingUrl: 'https://cot.aboutyou.com',
        zalandoUrl: 'https://www.zalando.fr/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.da_DK]: {
    environment: 'production',
    locale: Locale.da_DK,
    urlSets: [
      {
        hostname: 'www.aboutyou.dk',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_PRODUCTION,
        legacyCheckout: 'https://checkout.aboutyou.dk',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.da_DK],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_PRODUCTION,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.dk',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-live`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/production`,
        checkoutTrackingUrl: 'https://cot.aboutyou.com',
        zalandoUrl: 'https://www.zalando.dk/',
      },
      {
        hostname: 'm.aboutyou.dk',
        publicDesktopHostname: 'www.aboutyou.dk',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_PRODUCTION,
        legacyCheckout: 'https://checkout-m.aboutyou.dk',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.da_DK],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_PRODUCTION,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.dk',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-live`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/production`,
        checkoutTrackingUrl: 'https://cot.aboutyou.com',
        zalandoUrl: 'https://www.zalando.dk/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.sv_SE]: {
    environment: 'production',
    locale: Locale.sv_SE,
    urlSets: [
      {
        hostname: 'www.aboutyou.se',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_PRODUCTION,
        legacyCheckout: 'https://checkout.aboutyou.se',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.sv_SE],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_PRODUCTION,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.se',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-live`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/production`,
        checkoutTrackingUrl: 'https://cot.aboutyou.com',
        zalandoUrl: 'https://www.zalando.se/',
      },
      {
        hostname: 'm.aboutyou.se',
        publicDesktopHostname: 'www.aboutyou.se',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_PRODUCTION,
        legacyCheckout: 'https://checkout-m.aboutyou.se',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.sv_SE],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_PRODUCTION,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.se',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-live`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/production`,
        checkoutTrackingUrl: 'https://cot.aboutyou.com',
        zalandoUrl: 'https://www.zalando.se/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.fi_FI]: {
    environment: 'production',
    locale: Locale.fi_FI,
    urlSets: [
      {
        hostname: 'www.aboutyou.fi',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_PRODUCTION,
        legacyCheckout: 'https://checkout.aboutyou.fi',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.fi_FI],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_PRODUCTION,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.fi',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-live`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/production`,
        checkoutTrackingUrl: 'https://cot.aboutyou.com',
        zalandoUrl: 'https://www.zalando.fi/',
      },
      {
        hostname: 'm.aboutyou.fi',
        publicDesktopHostname: 'www.aboutyou.fi',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_PRODUCTION,
        legacyCheckout: 'https://checkout-m.aboutyou.fi',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.fi_FI],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_PRODUCTION,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.fi',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-live`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/production`,
        checkoutTrackingUrl: 'https://cot.aboutyou.com',
        zalandoUrl: 'https://www.zalando.fi/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.es_ES]: {
    environment: 'production',
    locale: Locale.es_ES,
    urlSets: [
      {
        hostname: 'www.aboutyou.es',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_PRODUCTION,
        legacyCheckout: 'https://checkout.aboutyou.es',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.es_ES],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_PRODUCTION,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.es',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-live`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/production`,
        checkoutTrackingUrl: 'https://cot.aboutyou.com',
        zalandoUrl: 'https://www.zalando.es/',
      },
      {
        hostname: 'm.aboutyou.es',
        publicDesktopHostname: 'www.aboutyou.es',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_PRODUCTION,
        legacyCheckout: 'https://checkout-m.aboutyou.es',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.es_ES],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_PRODUCTION,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.es',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-live`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/production`,
        checkoutTrackingUrl: 'https://cot.aboutyou.com',
        zalandoUrl: 'https://www.zalando.es/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.it_IT]: {
    environment: 'production',
    locale: Locale.it_IT,
    urlSets: [
      {
        hostname: 'www.aboutyou.it',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_PRODUCTION,
        legacyCheckout: 'https://checkout.aboutyou.it',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.it_IT],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_PRODUCTION,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.it',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-live`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/production`,
        checkoutTrackingUrl: 'https://cot.aboutyou.com',
        zalandoUrl: 'https://www.zalando.it/',
      },
      {
        hostname: 'm.aboutyou.it',
        publicDesktopHostname: 'www.aboutyou.it',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_PRODUCTION,
        legacyCheckout: 'https://checkout-m.aboutyou.it',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.it_IT],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_PRODUCTION,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.it',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-live`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/production`,
        checkoutTrackingUrl: 'https://cot.aboutyou.com',
        zalandoUrl: 'https://www.zalando.it/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.pt_PT]: {
    environment: 'production',
    locale: Locale.pt_PT,
    urlSets: [
      {
        hostname: 'www.aboutyou.pt',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_PRODUCTION,
        legacyCheckout: 'https://checkout.aboutyou.pt',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.pt_PT],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_PRODUCTION,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.pt',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-live`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/production`,
        checkoutTrackingUrl: 'https://cot.aboutyou.com',
        zalandoUrl: 'https://www.zalando.pt/',
      },
      {
        hostname: 'm.aboutyou.pt',
        publicDesktopHostname: 'www.aboutyou.pt',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_PRODUCTION,
        legacyCheckout: 'https://checkout-m.aboutyou.pt',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.pt_PT],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_PRODUCTION,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.pt',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-live`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/production`,
        checkoutTrackingUrl: 'https://cot.aboutyou.com',
        zalandoUrl: 'https://www.zalando.pt/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.el_GR]: {
    environment: 'production',
    locale: Locale.el_GR,
    urlSets: [
      {
        hostname: 'www.aboutyou.gr',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_PRODUCTION,
        legacyCheckout: 'https://checkout.aboutyou.gr',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.el_GR],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_PRODUCTION,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.gr',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-live`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/production`,
        checkoutTrackingUrl: 'https://cot.aboutyou.com',
        zalandoUrl: 'https://www.zalando.com/',
      },
      {
        hostname: 'm.aboutyou.gr',
        publicDesktopHostname: 'www.aboutyou.gr',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_PRODUCTION,
        legacyCheckout: 'https://checkout-m.aboutyou.gr',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.el_GR],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_PRODUCTION,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.gr',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-live`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/production`,
        checkoutTrackingUrl: 'https://cot.aboutyou.com',
        zalandoUrl: 'https://www.zalando.com/',
      },
    ],
    genderCookieSameDomain: true,
  },
  [Locale.el_CY]: {
    environment: 'production',
    locale: Locale.el_CY,
    urlSets: [
      {
        hostname: 'www.aboutyou.com.cy',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_PRODUCTION,
        legacyCheckout: 'https://checkout.aboutyou.com.cy',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.el_CY],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_PRODUCTION,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.com.cy',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-live`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/production`,
        checkoutTrackingUrl: 'https://cot.aboutyou.com',
        zalandoUrl: 'https://www.zalando.com/',
      },
      {
        hostname: 'm.aboutyou.com.cy',
        publicDesktopHostname: 'www.aboutyou.com.cy',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_PRODUCTION,
        legacyCheckout: 'https://checkout-m.aboutyou.com.cy',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.el_CY],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_PRODUCTION,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.com.cy',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-live`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/production`,
        checkoutTrackingUrl: 'https://cot.aboutyou.com',
        zalandoUrl: 'https://www.zalando.com/',
      },
    ],
  },
  [Locale.fr_LU]: {
    environment: 'production',
    locale: Locale.fr_LU,
    urlSets: [
      {
        hostname: 'www.aboutyou.lu',
        device: 'desktop',
        assetsUrl: ASSETS_URL_DESKTOP_PRODUCTION,
        legacyCheckout: 'https://checkout.aboutyou.lu',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.fr_LU],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_PRODUCTION,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.lu',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-live`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/production`,
        checkoutTrackingUrl: 'https://cot.aboutyou.com',
        zalandoUrl: 'https://www.zalando.lu/',
      },
      {
        hostname: 'm.aboutyou.lu',
        publicDesktopHostname: 'www.aboutyou.lu',
        device: 'mobile',
        assetsUrl: ASSETS_URL_MOBILE_PRODUCTION,
        legacyCheckout: 'https://checkout-m.aboutyou.lu',
        help_center_GET: desktopHelpCenterEndpointByLocale[Locale.fr_LU],
        sms_POST: sendSmsEndpoint,
        klarnaSdkUrl: KLARNA_SDK_URL_PRODUCTION,
        checkoutFrontendHost: 'https://checkout-v3.aboutyou.lu',
        checkoutShopsApiUrl: `https://checkout-cdn.aboutyou.cloud/shops/ayou-live`,
        checkoutAppUrl: `https://checkout-cdn.aboutyou.cloud/app/production`,
        checkoutTrackingUrl: 'https://cot.aboutyou.com',
        zalandoUrl: 'https://www.zalando.lu/',
      },
    ],
    genderCookieSameDomain: true,
  },
};
